import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, HttpApiQueryRepository } from '@softline/core';
import { QueryDataSource } from '@softapps/core';
import { SOFTLINE_API_ABC_ANALYSIS_FILTER_VALUES } from '../abc-analysis.api';
import { AbcAnalysisFilterRow } from '../types/abc-analysis-filter-row';

// Backs the pageFilter dropdowns (sales_organisation/supplier/product_group/
// department/promotion, see abc-analysis-query.filter.ts) via
// POST /statistics/abc-analysis/filter-values — a distinct-value query with the same
// StatementParameter shape as the ranking endpoint, just without triggering an ABC
// classification.
@Injectable()
export class AbcAnalysisFilterDataSourceService
  extends HttpApiQueryRepository<AbcAnalysisFilterRow>
  implements QueryDataSource<AbcAnalysisFilterRow>
{
  type = 'query' as const;

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ABC_ANALYSIS_FILTER_VALUES);
  }
}
